import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  header: {
    // backgroundColor: theme.agentTheme.secondary.main,
  },
  menu: {
    display: "none",
    [theme.breakpoints.down(900)]: {
      display: "block",
    },
  },
  footerHead: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "1rem",
    backgroundColor: theme.agentTheme.secondary.main,
    fontWeight: 600,
    borderBottomRightRadius: "2rem",
    borderBottomLeftRadius: "2rem",
    padding: "1rem 20rem",
    [theme.breakpoints.down(1400)]: {
      padding: "1rem 5rem",
    },
    [theme.breakpoints.down(900)]: {
      padding: "1rem 1rem",
      display: "none",
    },
  },
  contactContainer: {
    color: theme.agentTheme.secondary.foreground,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "&>span": {
      display: "flex",
      alignItems: "center",
    },
  },
  loginContainer: {
    color: theme.agentTheme.secondary.foreground,
  },
  loginButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: theme.agentTheme.secondary.foreground,
  },
  logoImg: {
    height: "40px",
    width: "auto",
    cursor: "pointer",
  },
  menuIcon: {
    color: theme.agentTheme.primary.main,
  },
  footerTail: {
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20rem",
    [theme.breakpoints.down(1400)]: {
      padding: "1rem 5rem",
      flexDirection: "column",
      gap: "1rem",
    },

    [theme.breakpoints.down(900)]: {
      padding: "10px 1rem",
      flexDirection: "row",
      justifyContent: "start",
    },
  },
  navbar: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "1.5rem",
    fontSize: "1rem",
    color: theme.agentTheme.text.link_text_color,
    [theme.breakpoints.down(900)]: {
      display: "none",
    },
  },

  navItem: {
    color: "currentColor",
    fontWeight: 700,
    letterSpacing: "0.05rem",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
  },

  // mobile Drawer styling
  contentTextSideNavbar: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginRight: "50px",
    cursor: "pointer",
    margin: theme.spacing(1, 0, 1, 1),
    display: "flex",
  },

  navbarContentContainer: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    marginLeft: "16px",
    borderBottom: `0.5px solid ${theme.agentTheme.card.muted_foreground}`,
  },

  mobileNavDrawer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.agentTheme.card.main,
    height: "100vh",
    width: "100%",
    paddingTop: "5px",
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch",
  },

  closeBtn: {
    marginRight: "40px",
  },

  closeIcon: {
    color: theme.agentTheme.card.link_foreground,
  },

  usernameText: {
    color: theme.agentTheme.card.link_foreground,
    marginLeft: "8px",
  },
}));

export default useStyles;
